import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FDF5EA] to-white">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link
            to="/"
            className="font-serif text-2xl font-medium text-[#2D2D2D] hover:text-[#C9A96E] transition-colors"
          >
            봄날 AI 웨딩
          </Link>
          <span className="text-sm text-gray-500">이용약관</span>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
          <h1 className="font-serif text-3xl font-light text-[#2D2D2D] mb-2">
            서비스 이용약관
          </h1>
          <p className="text-sm text-gray-400 mb-10">시행일: 2026년 4월 24일 (제정 2025년 1월 1일)</p>

          <div className="space-y-10 text-sm text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제1조 (목적)
              </h2>
              <p>
                본 약관은 솔버스(이하 "회사")가 운영하는 봄날 AI 웨딩(이하
                "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및
                책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제2조 (정의)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  "서비스"란 회사가 제공하는 AI 기반 웨딩 사진 생성 서비스를
                  말합니다.
                </li>
                <li>
                  "이용자"란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을
                  말합니다.
                </li>
                <li>
                  "회원"이란 서비스에 가입하여 이용자 계정을 부여받은 자를
                  말합니다.
                </li>
                <li>
                  "콘텐츠"란 서비스를 통해 생성된 AI 웨딩 사진 및 관련
                  결과물을 말합니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제3조 (약관의 효력 및 변경)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  본 약관은 서비스 화면에 게시하거나 기타의 방법으로
                  이용자에게 공지함으로써 효력이 발생합니다.
                </li>
                <li>
                  회사는 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할
                  수 있으며, 변경 시 적용일자 7일 전부터 공지합니다.
                </li>
                <li>
                  변경된 약관에 동의하지 않는 이용자는 서비스 이용을 중단하고
                  탈퇴할 수 있습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제4조 (서비스의 내용)
              </h2>
              <p className="mb-2">회사가 제공하는 서비스의 내용은 다음과 같습니다.</p>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>AI 기술을 활용한 웨딩 사진 생성 서비스</li>
                <li>다양한 스타일 및 톤의 웨딩 사진 선택 기능</li>
                <li>생성된 사진의 다운로드 및 공유 기능</li>
                <li>기타 회사가 정하는 서비스</li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제5조 (서비스 제공기간)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  서비스 제공기간은 결제 완료일로부터 <strong className="text-[#2D2D2D]">3개월</strong>로 합니다.
                </li>
                <li>
                  이용자는 서비스 제공기간 내에 생성된 사진의 재생성(사진당
                  최대 2회) 및 다운로드를 이용할 수 있습니다.
                </li>
                <li>
                  서비스 제공기간이 경과한 이후에는 재생성 및 다운로드 등
                  관련 기능의 이용이 제한될 수 있습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제6조 (서비스 이용계약의 성립)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  서비스 이용계약은 이용자가 본 약관에 동의하고 회원가입을
                  완료한 시점에 성립됩니다.
                </li>
                <li>
                  이용자는 회원가입 시 정확한 정보를 제공해야 하며, 허위 정보
                  제공 시 서비스 이용이 제한될 수 있습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제7조 (결제 및 환불)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  서비스 이용 요금은 서비스 내 안내된 요금제에 따르며, 모든
                  금액은 부가세(VAT)가 포함된 금액입니다.
                </li>
                <li>결제는 신용카드 등 회사가 정한 결제 수단으로 진행됩니다.</li>
                <li>
                  결제 완료 후 AI 이미지 생성이 시작되기 전까지 전액 환불이
                  가능합니다.
                </li>
                <li>
                  <strong className="text-[#2D2D2D]">
                    AI 이미지 생성이 시작된 이후에는 환불이 불가합니다.
                  </strong>
                </li>
                <li>
                  서비스 장애 등 회사의 귀책사유로 서비스가 제공되지 못한
                  경우에는 전액 환불합니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제8조 (이용자의 의무)
              </h2>
              <p className="mb-2">이용자는 다음 행위를 하여서는 안 됩니다.</p>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>타인의 개인정보 또는 사진을 무단으로 사용하는 행위</li>
                <li>
                  서비스를 통해 생성된 콘텐츠를 불법적인 목적으로 사용하는 행위
                </li>
                <li>서비스의 운영을 방해하는 행위</li>
                <li>회사의 지적재산권을 침해하는 행위</li>
                <li>기타 관련 법령에 위반되는 행위</li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제9조 (지적재산권)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  서비스 및 서비스에 포함된 기술, 디자인 등에 대한 지적재산권은
                  회사에 귀속됩니다.
                </li>
                <li>
                  이용자가 업로드한 사진의 저작권은 이용자에게 귀속되며, 회사는
                  서비스 제공 목적으로만 해당 사진을 이용합니다.
                </li>
                <li>
                  서비스를 통해 생성된 AI 웨딩 사진에 대한 사용권은
                  이용자에게 부여되며, 개인적 용도로 자유롭게 사용할 수
                  있습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제10조 (서비스의 중단)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  회사는 시스템 점검, 설비 교체 등 부득이한 사유가 있는 경우
                  서비스의 전부 또는 일부를 일시적으로 중단할 수 있습니다.
                </li>
                <li>
                  서비스 중단 시 사전에 공지하며, 불가피한 경우 사후에
                  공지할 수 있습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제11조 (면책조항)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 등
                  불가항력으로 인해 서비스를 제공할 수 없는 경우 책임을 지지
                  않습니다.
                </li>
                <li>
                  AI 기술의 특성상 생성된 결과물의 품질은 업로드된 사진의 품질,
                  해상도 등에 따라 달라질 수 있으며, 이에 대해 회사는 완벽한
                  결과를 보장하지 않습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제12조 (분쟁 해결)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  서비스 이용과 관련하여 분쟁이 발생한 경우, 회사와 이용자는
                  상호 협의하여 해결합니다.
                </li>
                <li>
                  협의가 되지 않을 경우, 관할 법원은 회사의 본사 소재지를
                  관할하는 법원으로 합니다.
                </li>
              </ol>
            </section>

            <section className="bg-[#FDF5EA] rounded-xl p-5">
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                회사 정보
              </h2>
              <ul className="space-y-1.5">
                <li>상호: 솔버스</li>
                <li>대표: 정홍기</li>
                <li>사업자등록번호: 561-07-03011</li>
                <li>주소: 서울특별시 성동구 무학봉 16길 22, 3층</li>
                <li>이메일: solvers.official@gmail.com</li>
                <li>전화번호: 010-2940-2884</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
